// extracted by mini-css-extract-plugin
module.exports = {"button":"e2ff468f85--button--qoCHE","button-text":"e2ff468f85--button-text--A4Vud"};